import React from 'react';

const NoDataPlaceholder = ({ type, title, subtitle, minHeight = '200px', style = {} }) => {
  const getIcon = () => {
    const strokeColor = '#737373';
    switch (type) {
      case 'profit':
        return (
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" stroke={strokeColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            {/* Base Line */}
            <line x1="8" y1="38" x2="40" y2="38" />
            {/* Left column (x=13, y=24, w=7, h=14) */}
            <path d="M13 38V24H20V38" />
            {/* Center column (x=20, y=16, w=7, h=22) */}
            <path d="M20 38V16H27V38" />
            {/* Right column (x=27, y=30, w=7, h=8) */}
            <path d="M27 38V30H34V38" />
            {/* Star on top of center bar (centered at x=23.5, y=10) */}
            <path d="M23.5 4 L25 8 L29.5 8 L26 11 L27 15.5 L23.5 13 L20 15.5 L21 11 L17.5 8 L22 8 Z" fill={strokeColor} />
          </svg>
        );
      case 'compare':
        return (
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" stroke={strokeColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            {/* Stand */}
            <line x1="24" y1="12" x2="24" y2="38" />
            <path d="M16 38H32" />
            {/* Horizontal beam */}
            <line x1="12" y1="16" x2="36" y2="16" />
            {/* Left pan strings and pan */}
            <path d="M12 16L7 28H17L12 16Z" fill="none" />
            {/* Right pan strings and pan */}
            <path d="M36 16L31 28H41L36 16Z" fill="none" />
          </svg>
        );
      case 'sales':
        return (
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" stroke={strokeColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            {/* Hollow Bullet Circles */}
            <circle cx="14" cy="16" r="2.5" />
            <circle cx="14" cy="24" r="2.5" />
            <circle cx="14" cy="32" r="2.5" />
            {/* Lines with varied lengths */}
            <line x1="22" y1="16" x2="36" y2="16" />
            <line x1="22" y1="24" x2="32" y2="24" />
            <line x1="22" y1="32" x2="28" y2="32" />
          </svg>
        );
      case 'stock':
        return (
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" stroke={strokeColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M24 8L38 15V33L24 40L10 33V15L24 8Z" />
            <path d="M10 15L24 22L38 15" />
            <path d="M24 22V40" />
          </svg>
        );
      case 'usage':
      default:
        return (
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" stroke={strokeColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            {/* Main thick path */}
            <path d="M8 32 L15 22 L22 28 L30 14 L37 26 L42 20" strokeWidth="3.5" />
            {/* Secondary offset path (dashed) */}
            <path d="M8 26 L15 16 L22 22 L30 8 L37 20 L42 14" stroke="#d1d5db" strokeWidth="2" strokeDasharray="3 3" />
          </svg>
        );
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px 16px',
        textAlign: 'center',
        height: '100%',
        minHeight: minHeight,
        boxSizing: 'border-box',
        ...style
      }}
    >
      <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'center' }}>
        {getIcon()}
      </div>
      <h4
        style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#111827',
          margin: '0 0 8px 0',
          lineHeight: '1.3'
        }}
      >
        {title}
      </h4>
      <p
        style={{
          fontSize: '13px',
          color: '#4b5563',
          margin: 0,
          lineHeight: '1.4',
          maxWidth: '280px'
        }}
      >
        {subtitle}
      </p>
    </div>
  );
};

export default NoDataPlaceholder;
